
define('template!ordersBoardView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="filters-region"></div>\n<div class="header-region"></div>\n<div class="kanban-region"></div>\n';

}
return __p
};});

